var $d5863f94ad4c3f07$exports = {};
$d5863f94ad4c3f07$exports = {
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};


export {$d5863f94ad4c3f07$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
